import { createMemoStyles } from '@wds/utils';
import { PricingAppTheme } from '~app/styles/pricing/types';
import { MD_MEDIA_QUERY } from '~shared/media-query';
import DotGrid from './assets/DotGrid.svg';

export default createMemoStyles(({ spacing, pricingPalette, radius, type }: PricingAppTheme) => ({
  BannerRow: {
    padding: [0, '15%'],
  },
  BannerContainer: {
    background: `url(${DotGrid}) left bottom no-repeat ${pricingPalette.colors.dijon}`,
    width: '100%',
    height: 80,
    marginTop: spacing[6],
    borderRadius: 4,
    border: `2px solid ${pricingPalette.colors.black}`,
    overflow: 'hidden',
    display: 'none',
    [MD_MEDIA_QUERY]: {
      display: 'flex',
    },
  },

  DiscountLargeText: {
    '& div': {
      fontFamily: 'National 2',
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: type.fontSize.sectionTitleSm,
      lineHeight: 1,
      marginRight: spacing[2],
      marginLeft: spacing[6],
    },
  },

  TryNowBox: {
    backgroundColor: pricingPalette.colors.bumblebee,
    borderRadius: '150px 0px 70px 0px',
    width: 320,
    height: 200,
    marginTop: -59,
  },

  ViewPlansButton: {
    padding: [spacing[1], spacing[4]],
    backgroundColor: pricingPalette.colors.navy,
    color: pricingPalette.colors.white,
    fontFamily: 'National 2',
    fontWeight: 500,
    fontSize: spacing[4],
    borderRadius: radius.small,
    width: 160,
    height: spacing[6],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
      textDecoration: 'none',
    },
  },
}));
